import { TrackAggregationGroup } from '@36node-fcp/core-sdk';
import { useCallback } from 'react';

import { useTrackRecordAggregation } from './track-record';

export type TrackVehicleReportRequest = {
  createAt_gt?: string;
  createAt_lt?: string;
  count_gt?: number; // 违法次数大于
};

export type TrackVehicleReportItem = {
  count: number;
  plate: string;
};

export const useIllegalVehicleReport = (req?: TrackVehicleReportRequest) => {
  const [{ result, loading, request }, listTrackRecordAggregations] = useTrackRecordAggregation({
    _group: [TrackAggregationGroup.PLATE],
    _limit: 1000,
    _offset: 0,
    _count_gt: req?.count_gt,
    createAt_gt: req?.createAt_gt,
    createAt_lt: req?.createAt_lt,
  });

  const refresh = useCallback(() => {
    listTrackRecordAggregations(request);
  }, [request]);

  const list: TrackVehicleReportItem[] =
    result
      ?.filter((item) => Boolean(item['plate']))
      .map((item) => {
        return {
          count: item.count,
          plate: item['plate'],
        };
      }) || [];

  return [{ loading, result: list, total: list?.length }, refresh] as const;
};
